const asyncActionType = type => ({
  pending: `${type}_PENDING`,
  success: `${type}_SUCCESS`,
  error: `${type}_ERROR`
});

export const LOAD_MAP = asyncActionType('aerosimple/map/LOAD');
export const FETCH_PORTAL_TILES = asyncActionType('FETCH_PORTAL_TILES');
export const ADD_SUBSCRIPTION = asyncActionType('POST_PORTAL_TILES_SUBSCRIPTION');
export const CLEAR_ACTION = 'CLEAR_ACTION';
export const FETCH_PORTAL_TILES_ALINGMENT = asyncActionType('FETCH_PORTAL_TILES_ALINGMENT');
